import { render, staticRenderFns } from "./Metatexts.vue?vue&type=template&id=7f37f3de&scoped=true&"
import script from "./Metatexts.vue?vue&type=script&lang=js&"
export * from "./Metatexts.vue?vue&type=script&lang=js&"
import style0 from "./Metatexts.vue?vue&type=style&index=0&id=7f37f3de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f37f3de",
  null
  
)

export default component.exports